import React, { Suspense } from 'react';

import { useTranslation } from 'react-i18next';
import { ErrorButtonStyled } from 'shared/components/ErrorBoundary/ErrorBoundary.styles';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import { Body, ErrorBodyWrapper, HeaderText } from './ErrorBody.styles';

const ErrorLaptopImg = React.lazy(() => import('shared/components/icons/ErrorLaptopImg'));
interface ErrorBodyProps {
  onClick: () => void;
}
export function ErrorBody({ onClick }: ErrorBodyProps) {
  const { t } = useTranslation();
  return (
    <ErrorBodyWrapper>
      <Suspense fallback={<LoadingSpinner />}>
        <ErrorLaptopImg width="193" height="177" />
      </Suspense>
      <HeaderText as="p">{t('inbox.error.subject')}</HeaderText>
      <Body as="p">{t('inbox.error.body')}</Body>
      <ErrorButtonStyled
        $isFullWidth
        $maxWidth="100%"
        onClick={onClick}
        onKeyUp={(e) => {
          if (e.key === 'Enter' || e.key === ' ') onClick();
        }}
      >
        {t('inbox.error.button')}
      </ErrorButtonStyled>
    </ErrorBodyWrapper>
  );
}
export default ErrorBody;
